var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 10,
    fill: "#F5F5F7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 50,
    y2: 10,
    stroke: "#1D1D1F",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 20,
    x2: 50,
    y2: 20,
    stroke: "#1D1D1F",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 30,
    x2: 50,
    y2: 30,
    stroke: "#1D1D1F",
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 40,
    x2: 50,
    y2: 40,
    stroke: "#1D1D1F",
    strokeWidth: 1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 50,
    x2: 50,
    y2: 50,
    stroke: "#1D1D1F",
    strokeWidth: 1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 10,
    y2: 50,
    stroke: "#1D1D1F",
    strokeWidth: 1
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 10,
    x2: 20,
    y2: 50,
    stroke: "#1D1D1F",
    strokeWidth: 1
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 10,
    x2: 30,
    y2: 50,
    stroke: "#1D1D1F",
    strokeWidth: 1
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 10,
    x2: 40,
    y2: 50,
    stroke: "#1D1D1F",
    strokeWidth: 1
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 10,
    x2: 50,
    y2: 50,
    stroke: "#1D1D1F",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 8,
    fill: "#000000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 8,
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0ff90bef2702b2ab1a4d99a221370b9f.svg";
export { ForwardRef as ReactComponent };